<template>
  <div class="container py-5">
    <h1 class="display-6 text-center">Computer Science Overview</h1>
  <!-- Intro Section -->
    <div class="lead text-center mb-5">
      Specialized in empowering students with the skills and knowledge to excel in various aspects of Computer Science. Whether you're tackling GCSE content or navigating the demands of university-level modules, we’re here to guide you every step of the way.
    </div>
    <div class="row">
      <!-- Vertical Nav -->
      <div class="col-md-4 mb-3">
        <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
          <button
            v-for="(topic, index) in topics"
            :key="index"
            class="nav-link py-2 px-3 mb-2"
            :class="{ active: activeTab === index }"
            @click="activeTab = index"
            type="button"
            role="tab"
          >
            {{ topic.title }}
          </button>
        </div>
      </div>

      <!-- Tab Content -->
      <div class="col-md-8">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h5 class="card-title text-success">{{ topics[activeTab].title }}</h5>
            <!-- p class="card-text">{{ topics[activeTab].description }}</p -->
            <div class="card-text" v-html="topics[activeTab].description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OverviewView',
  data() {
    return {
      activeTab: 0,
      topics: [
        {
          title: 'Computer Science (Theory)',
          description: 'Understanding the "why" behind computational concepts is just as crucial as knowing how to code. We delve into topics like computational thinking, hardware architecture, networking, and artificial intelligence to solidify your grasp of core theoretical principles.'
        },
        {
          title: 'Computer Science (Programming)',
          description: 'We focus on sharpening your programming abilities, ensuring you can confidently write, debug, and optimize code. Through practical exercises and real-world scenarios, students develop problem-solving skills essential for success in the field.'
        },
        {
          title: 'Network/Internet Technologies',
          description: 'University-level Computer Science can be challenging. We provide expert guidance on coursework, exams, and projects, ensuring clarity and confidence as students tackle complex concepts like machine learning, software engineering, and advanced databases.'
        },
        {
          title: 'Software & Apps Development',
          description: 'It is the study of discrete objects. Here, discrete means containing distinct or unconnected elements.'
        },
        {
          title: 'Cyber Security',
          description: 
           `
          <p>Cyber security refers to the set of strategies, technologies, and practices used to protect digital systems—such as computers, mobile devices, networks, and data—from cyber threats, such as hacking, malware, and unauthorised access.</p>
          <p>Students should understand that the main purposes of cyber security are to ensure:</p>
          <ul>
            <li><strong>Confidentiality</strong> - keeping information private and secure</li>
            <li><strong>Integrity</strong> - ensuring data is accurate and has not been tampered with</li>
            <li><strong>Availability</strong> - making sure systems and data are accessible when needed</li>
          </ul>
          <p><strong>Students should also be able to:</strong></p>
          <ul>
            <li>Define <em>cyber security</em> as the protection of computer systems and networks from cyber attacks.</li>
            <li>Describe its primary objectives: <strong>protecting data confidentiality</strong>, <strong>preventing unauthorised access</strong>, and <strong>ensuring data and systems remain accurate and available</strong>.</li>
            <li>Understand that cyber security includes measures such as <em>firewalls, encryption, user access levels</em>, and <em>network policies</em>.</li>
            <li>Identify threats like <em>phishing, malware, and social engineering</em>.</li>
          </ul>
        `
        },
        {
          title: 'Artifical Intelligence',
          description: 
          `
          <p><strong>Artificial Intelligence (AI)</strong> is a part of computer science that tries to make computers behave like the human brain processes information. This means copying how people think, learn, solve problems, speak, and see. These thinking skills are called cognitive functions — they help us understand the world through our thoughts, experiences, and senses. AI tries to make machines do the same things, and we compare how well they do it to how humans do.
          </p>
          <p><strong>Reasoning</strong> is the ability to make smart decisions based on facts or situations. One type is called deductive reasoning, which means using known facts to create rules that can help solve other problems.

          For example, imagine AI learns how to cook the perfect pizza by following facts like temperature, time, and ingredients. Once it gets it right, it can use what it learned to make other dishes like garlic bread or pasta — adjusting its method when needed. This shows how AI can apply rules from one task to similar tasks.</p>
          `      
},
      
      ]
    };
  }
};
</script>

<style scoped>
.nav-link {
  cursor: pointer;
}
.card-title {
  font-weight: 600;
}
.nav-link {
  background-color: #f8f9fa !important;
  color: #000 !important;
  border: 1px solid #dee2e6 !important;
}

.nav-link:hover {
  background-color: #e9f5ee !important;
  color: #000 !important;
}


.nav-link.active {
  background-color: #198754 !important;
  color: #fff !important;
  border-color: #198754 !important;
  font-weight: 600;
}





</style>
